<input type="file"
       #fileInputEl
       [style.display]="'none'"
       (change)="!disabled ? handleFileInput($event.target) : null">
<img [src]="image ? image : placeholder"
     (click)="!disabled ? fileInputEl.click() : null"
     class="image">
